export interface TopUpLoan {
  current_loan: {
    quota_amount: number;
    balance: number;
  };
  consolidation: {
    total_new_credit: number;
    discount: number;
    total_financed: number;
  };
  new_loan: {
    installment: number;
    quota_amount: number;
    frequency: number;
    quota_quantity: number;
  };
  advance_payment: number;
  first_payment_date: string;
}

export const EMPTY_TOP_UP_LOAN: TopUpLoan = {
  current_loan: { quota_amount: 0, balance: 0 },
  consolidation: { total_new_credit: 0, discount: 0, total_financed: 0 },
  new_loan: { installment: 0, quota_amount: 0, frequency: 0, quota_quantity: 0 },
  advance_payment: 0,
  first_payment_date: ''
};
